import { CSSProperties } from 'react';

import UIConfig from '@/UIConfig.ts';

export const containerStyle: CSSProperties = {
  width: '100%',
  height: '100%',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  background: UIConfig.Colors.BackgroundDark,
  zIndex: 2,
  paddingBottom: 100
};

export const scrollableContentStyle: CSSProperties = {
  width: '100%',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center'
};

export const fixedFooterStyle: CSSProperties = {
  position: 'fixed',
  bottom: 0,
  left: 0,
  right: 0,
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  background: UIConfig.Colors.BackgroundDark,
  paddingTop: 5,
  paddingBottom: 10,
  zIndex: 10
};

export const bottomGradientStyle: CSSProperties = {
  position: 'absolute',
  top: -35,
  left: 0,
  right: 0,
  height: 35,
  background: `linear-gradient(to bottom, transparent, ${UIConfig.Colors.BackgroundDark})`,
  pointerEvents: 'none',
  zIndex: 5
};

export const headerStyle: CSSProperties = {
  display: 'flex',
  flexDirection: 'column',
  width: '100%',
  alignItems: 'center',
  marginTop: '5px'
};

export const headlineStyle: CSSProperties = {
  color: '#FFF',
  fontSize: '30px',
  fontWeight: '700',
  marginBottom: '5px',
  display: 'flex',
  alignItems: 'center'
};

export const subTitleStyle: CSSProperties = {
  color: '#e0e0e0',
  margin: '0px',
  padding: 0,
  fontWeight: 400,
  fontSize: '15px',
  letterSpacing: '0.3px',
  textAlign: 'center',
  lineHeight: '1.4'
};

export const selectorContainerStyle: CSSProperties = {
  width: '90%',
  padding: '0',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  marginTop: '15px'
};

export const selectorBlockStyle: CSSProperties = {
  width: '100%',
  background: 'rgba(255, 255, 255, 0.15)',
  backdropFilter: 'blur(10px)',
  borderRadius: '10px',
  padding: '0'
};

export const benefitsContainerStyle: CSSProperties = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
  justifyContent: 'center',
  textAlign: 'left',
  padding: '5px',
  width: '90%'
};

export const benefitsHeaderStyle: CSSProperties = {
  color: '#FFF',
  fontSize: '14px',
  fontWeight: 400
};

export const benefitStyle: CSSProperties = {
  color: '#FFF',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  marginTop: '13px',
  fontSize: '15px',
  width: '100%'
};
